import {isMobileAOS} from '../tools';
import iconCross from '../../images/icon-cross.png';
import iconRibbon from '../../images/icon-ribbon.png';

export default function initializeObituary() {
  initializeObituarySearchForm();
}

function initializeObituarySearchForm() {
  let form = document.querySelector( '.obituary-form' ),
      loader = document.querySelector( '.block-obituary .loader-container' ),
      container = document.querySelector( '.obituaries-container' ),
      pagination = document.querySelector( '.obituaries-pagination' );

  loader.style.display = 'block';
  container.style.display = 'none';
  pagination.style.display = 'none';

  loadAjaxObituaries( '', document.body.dataset.lang ).then( data => {
    setObituaryHtmlResults( data );
    loader.style.display = 'none';
    container.style.display = 'flex';
    pagination.style.display = 'flex';
  } );

  if (form) {
    form.addEventListener( 'submit', function( e ) {
      e.preventDefault();
      loader.style.display = 'block';
      container.style.display = 'none';
      pagination.style.display = 'none';

      let name = document.querySelector( '.obituary-form__input' );
      loadAjaxObituaries( name.value, document.body.dataset.lang ).
          then( data => {
            setObituaryHtmlResults( data );
            loader.style.display = 'none';
            container.style.display = 'flex';
            pagination.style.display = 'flex';
          } );
    } );
  }

  document.addEventListener('click', function (e) {
    if(e.target.classList.contains('ajax-pagination')) {
      e.preventDefault();
      let page = parseInt(e.target.dataset.page);
      if(page) {
        loader.style.display = 'block';
        container.style.display = 'none';
        pagination.style.display = 'none';
        let name = document.querySelector( '.obituary-form__input' );

        scrollTopContainer();
        loadAjaxObituaries( name.value||'', document.body.dataset.lang, page ).
            then( data => {
              setObituaryHtmlResults( data, true );
              loader.style.display = 'none';
              container.style.display = 'flex';
              pagination.style.display = 'flex';
            } );
      }
    }
  });

}


function addObituaries( obituaries, translations ) {
  let container = document.querySelector( '.obituaries-container' );
  container.innerHTML = '';

  let html = '';

  for (let i = 0; i < obituaries.length; i++) {
    let delay = i % 3 === 0 ? '0' : '150';

    let dataAOS = 'data-aos="fade-right" data-aos-anchor-placement="top-bottom" data-aos-delay="' +
        delay + '" data-aos-duration="500"';

    if (isMobileAOS()) {
      dataAOS = '';
    }

    html += '<div class="col-12 col-md-6 col-lg-4">' +
        '<div class="obituary obituary--tease" ' + dataAOS + '>' +
        '<div class="obituary__shape-container obituary__shape-container--reversed">' +
        '<div class="obituary__shape"></div>' +
        '</div>' +
        '<div class="obituary__inner">' +
        '<div class="obituary__icon-container">';

    if (obituaries[i].fields.obituary_group.icon === 'cross') {
      html += '<img class="obituary__icon obituary__icon--cross" src="' +
          iconCross + '" alt=""/>';
    } else {
      html += '<img class="obituary__icon obituary__icon--ribbon" src="' +
          iconRibbon + '" alt=""/>';
    }

    html += '</div>' +
        '<div class="obituary__short-description">' +
        obituaries[i].fields.obituary_group.short_description +
        '</div>';

    if (obituaries[i].fields.obituary_group.icon === 'cross') {
      html += '<div class="obituary__appendix">' + translations.late + '</div>';
    }

    if (obituaries[i].fields.obituary_group.prefix_name.length > 0) {
      html += '<div class="obituary__prefix-name">' + obituaries[i].fields.obituary_group.prefix_name + '</div>';
    }

    html += '<div class="obituary__name">' +
        obituaries[i].fields.obituary_group.name +
        '</div>' +
        '<div class="obituary__date-container">' +
        '<span class="obituary__date-label">' + translations.date + '</span>' +
        '<span class="obituary__date">' +
        obituaries[i].fields.obituary_group.date + '</span>' +
        '</div>' +
        '<div class="obituary__link-container">' +
        '<a class="obituary__link" href="' + obituaries[i].link + '">' +
        translations.details + '</a>' +
        '</div>' +
        '</div>' +
        '<div class="obituary__shape-container">' +
        '<div class="obituary__shape obituary__shape--bottom"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
  }

  container.insertAdjacentHTML( 'beforeend', html );
}

function addPagination( current, pages ) {
  let html = '';
  if (pages > 1) {

    let pagination_links = [];
    let last_item_skipped = false;

    for (let i = 1; i <= pages; i++) {

      if (pages > 5) {
        if ((i < pages && current < i - 2) || (i < current - 2 && i > 1)) {
          if (last_item_skipped === true) {
            continue;
          }
          pagination_links.push( {
            link: '',
            title: '...',
            current: false,
          } );
          last_item_skipped = true;
          continue;
        }
      }

      last_item_skipped = false;
      pagination_links.push( {
        page: i,
        link: '',
        title: i,
        current: i === current,
      } );
    }

    if (pagination_links.length > 1) {
      html += '<nav class="pagination">';
      html += '<ul class="pagination__list">';
      pagination_links.forEach( function( item ) {
        html += paginationItem(item)
      } );
      html += '</ul>';
      html += '</nav>';
    }
  }
  document.querySelector( '.obituaries-pagination' ).innerHTML = html;
}

function paginationItem(item) {
  let html = '';
  if (item.current === true) {
    html += '<li class="pagination__item pagination__item--current">';
    html += '<span class="pagination__link" href="" role="button">';
    html += item.title;
    html += '</span>';
    html += '</li>';
  } else if(item.title === '...') {
    html += '<li class="pagination__item--number dots">';
    html += '<span href="" class="pagination__link">';
    html += item.title;
    html += '</span>';
    html += '</li>';
  } else {
    html += '<li class="pagination__item--number">';
    html += '<a href="" class="pagination__link ajax-pagination" href="" role="button" data-page="' +
        item.page + '">';
    html += item.title;
    html += '</a>';
    html += '</li>';
  }

  return html;
}

function setObituaryHtmlResults( data ) {
  let obituaries = data.results,
      translations = data.translations;
  addObituaries( obituaries, translations );
  addPagination( data.current_page, data.pages );
}

function scrollTopContainer() {
  let offset = -30;

  const container = document.querySelector( '.obituary-form-container' );
  const rect = container.getBoundingClientRect();
  let scrollPos = rect.top + window.scrollY;

  window.scrollTo({
    top: scrollPos + offset,
    behavior: 'smooth'
  });
}

async function loadAjaxObituaries( name, lang, page = 1 ) {
  const params = {
    name: name,
    lang: lang,
    page: page,
  };

  const url = window.location.origin + '/wp-json/skrzydlewska/v1/obituaries/?' +
      new URLSearchParams( params );

  const request = new Request( url, {
    method: 'GET',
  } );

  const response = await fetch( request );

  return response.json();
}